import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from 'components/Header';
import Logout from 'images/logout.svg';
import WarningPrimary from 'images/warning-primary.svg';
import CheckSecondary from 'images/check-secondary.svg';
import Chip from 'components/Chip';
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { useAuth } from 'contexts/auth';
import { When } from 'react-if';
import { Outlet, redirect, useNavigate } from 'react-router-dom';
import { IDivida } from 'interfaces/Divida';
import { IAcordo } from 'interfaces/Acordo';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${props => props.theme.breakpoints.up('sm')} {
    height: calc(100vh - 120px);
  }
`;

const LogoutButton = styled(Button).attrs({
  startIcon: <img src={Logout} alt="Logout Icon" />,
})`
  color: #252525;
  text-transform: none;
  margin-top: auto;
  position: fixed;
  bottom: 10px;
`;

export default function LoggedLayout() {
  const { signOut, user, dividasAuthContext, acordosAuthContext } = useAuth();
  const [dividas, setDividas] = useState<IDivida[] | undefined>([]);
  const [acordos, setAcordos] = useState<IAcordo[] | undefined>([]);
  const { signed } = useAuth();
  const navigate = useNavigate()

  useEffect(() => {
    setDividas(dividasAuthContext);
    setAcordos(acordosAuthContext);
  }, [dividasAuthContext, acordosAuthContext]);

  useEffect(
    () => {
      if (!signed) {
        navigate('/login')
      }
    }, []
  )

  const cpfMask = `${user?.cnpJ_CPF?.slice(0, 3)}.${user?.cnpJ_CPF?.slice(
    3,
    6,
  )}.***`;

  return (
    <Wrapper>
      <Header logged={true} />

      <Container style={{ paddingTop: 20, paddingBottom: 20 }}>
        <Grid container spacing={3}>

          <Grid item xs={12} sm={4} style={{ position: 'relative' }}>
            <LeftContent>
              <Typography variant="h5">
                <strong>{user?.nome}</strong>
              </Typography>
              <Box mt={1}>
                <Typography variant="body2">
                  <strong>CPF: </strong>
                  <span>{cpfMask}</span>
                </Typography>
              </Box>
              <When condition={!!dividas?.length}>
                <Box mt={2}>
                  <Chip
                    label="Débitos afetando seu CPF"
                    color="primary"
                    icon={<img src={WarningPrimary} alt="Warning" />}
                  />
                </Box>
              </When>
              <When condition={!!acordos?.length}>
                <Box mt={2}>
                  <Chip
                    label={`${acordos?.length} Acordos em andamento`}
                    color="secondary"
                    icon={<img src={CheckSecondary} alt="Check" />}
                  />
                </Box>
              </When>
              <LogoutButton onClick={
                () => {
                  signOut()
                  navigate('/login')
                }
              }>
                Sair
              </LogoutButton>
            </LeftContent>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Outlet />
          </Grid>

        </Grid>
      </Container>
    </Wrapper>
  );
}
